// extracted by mini-css-extract-plugin
export default {"mainContainer":"Checkbox_mainContainer__iufqb"};